import type { DateRangePickerProps, DateValue } from "react-aria-components";
import {
  DateInput,
  DateRangePicker,
  Label,
  RangeCalendar,
} from "react-aria-components";

import {
  CalendarDateSegment,
  CalendarDialog,
  CalendarFieldGroup,
  CalendarI18nProvider,
  CalendarMonth,
  CalendarPopover,
  CalendarTriggerButton,
} from "./calendar-parts";

interface CustomDateRangePickerProps extends Omit<
  DateRangePickerProps<DateValue>,
  "children"
> {
  readonly label?: string;
  readonly className?: string;
}

export function CustomDateRangePicker({
  label,
  className,
  ...props
}: Readonly<CustomDateRangePickerProps>) {
  return (
    <CalendarI18nProvider>
      <DateRangePicker
        {...props}
        className={`group flex flex-col gap-1 ${className || ""}`}
      >
        {label && (
          <Label className="text-text-secondary block text-sm font-medium">
            {label}
          </Label>
        )}
        <CalendarFieldGroup>
          <div className="flex flex-1 items-center">
            <DateInput slot="start" className="flex">
              {(segment) => <CalendarDateSegment segment={segment} />}
            </DateInput>
            <span aria-hidden className="text-text-secondary px-1">
              -
            </span>
            <DateInput slot="end" className="flex">
              {(segment) => <CalendarDateSegment segment={segment} />}
            </DateInput>
          </div>
          <CalendarTriggerButton />
        </CalendarFieldGroup>
        <CalendarPopover>
          <CalendarDialog>
            <RangeCalendar>
              <CalendarMonth selection="range" />
            </RangeCalendar>
          </CalendarDialog>
        </CalendarPopover>
      </DateRangePicker>
    </CalendarI18nProvider>
  );
}
